import React, { type JSX } from "react";
import type { ChatFeedback } from "../../hooks/useChatFeedback";

const TEXTAREA_ROWS = 3;

/**
 * Free-text follow-up after a thumbs down. Spans the full chat width and is only
 * offered for the latest bot message.
 */
export default function TextFeedbackBox({
  feedback,
  chatMessages,
}: {
  feedback: ChatFeedback;
  chatMessages: any[];
}): JSX.Element | null {
  const index = feedback.latestBotMessageIndex;

  if (index < 0 || !feedback.showTextFeedback[index] || !chatMessages[index]?.turnId) {
    return null;
  }

  return (
    <div className="w-full mt-2 px-3 sm:px-4 py-3 bg-gray-50 border-t border-gray-200">
      <label className="block text-xs text-gray-600 mb-2">What could be improved?</label>
      <textarea
        value={feedback.textFeedback[index] || ""}
        onChange={(e) =>
          feedback.setTextFeedback((prev) => ({ ...prev, [index]: e.target.value }))
        }
        placeholder="Share your thoughts..."
        className="w-full px-3 py-2 text-sm border border-gray-300 rounded-sm resize-none focus:outline-hidden focus:ring-1 focus:ring-blue-500"
        rows={TEXTAREA_ROWS}
      />
      <div className="flex gap-2 mt-2">
        <button
          onClick={() => feedback.handleTextFeedbackSubmit(index)}
          className="px-3 py-1 text-xs bg-cvc-blue text-white rounded-sm hover:bg-cvc-blue/90 transition-colors duration-200"
        >
          Submit
        </button>
        <button
          onClick={() => feedback.hideTextFeedback(index)}
          className="px-3 py-1 text-xs bg-gray-300 text-gray-700 rounded-sm hover:bg-gray-400 transition-colors duration-200"
        >
          Skip
        </button>
      </div>
    </div>
  );
}
